/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamAnswerAiCorrectionBatch200,
  PostApiV1ExamAnswerAiCorrectionBatch400,
  PostApiV1ExamAnswerAiCorrectionBatch401,
  PostApiV1ExamAnswerAiCorrectionBatch500,
  PostApiV1ExamAnswerAiCorrectionBatchMutationRequest,
  PostApiV1ExamAnswerAiCorrectionBatchMutationResponse,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamAnswerAiCorrectionBatch.ts";
import { examItemAnswerAiCorrectionViewModelSchema } from "../examItemAnswerAiCorrectionViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ExamAnswerAiCorrectionBatch200Schema = z.array(
  z.lazy(() => examItemAnswerAiCorrectionViewModelSchema),
) as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatch200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamAnswerAiCorrectionBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamAnswerAiCorrectionBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamAnswerAiCorrectionBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatch500>;

export const postApiV1ExamAnswerAiCorrectionBatchMutationRequestSchema =
  z.array(
    z.number().int(),
  ) as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatchMutationRequest>;

export const postApiV1ExamAnswerAiCorrectionBatchMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamAnswerAiCorrectionBatch200Schema,
  ) as unknown as ToZod<PostApiV1ExamAnswerAiCorrectionBatchMutationResponse>;
